<template>
  <div class="locale-switcher" role="group" :aria-label="ariaLabel">
    <button
      type="button"
      class="locale-switcher__btn"
      :class="{ 'is-active': currentLocale === 'en' }"
      @click="switchTo('en')"
    >
      EN
    </button>
    <span class="locale-switcher__sep" aria-hidden="true">|</span>
    <button
      type="button"
      class="locale-switcher__btn"
      :class="{ 'is-active': currentLocale === 'zh' }"
      @click="switchTo('zh')"
    >
      中文
    </button>
  </div>
</template>

<script>
import { getLocale, setLocale } from '@/i18n'

export default {
  name: 'LocaleSwitcher',
  computed: {
    currentLocale() {
      return getLocale()
    },
    ariaLabel() {
      return this.currentLocale === 'zh' ? '语言切换' : 'Language'
    }
  },
  methods: {
    switchTo(locale) {
      if (locale === this.currentLocale) return
      setLocale(locale)
    }
  }
}
</script>

<style scoped>
.locale-switcher {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 8px;
  font-size: 16px;
  line-height: 1;
}

.locale-switcher__btn {
  padding: 4px 2px;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  opacity: 0.65;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.locale-switcher__btn:hover {
  opacity: 1;
}

.locale-switcher__btn.is-active {
  opacity: 1;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.locale-switcher__sep {
  opacity: 0.45;
  user-select: none;
}
</style>
